module.exports = __webpack_public_path__ + "assets/images/173366a8aca177a82efae8b1a917004b.png";